import { Participant } from '../types/global'
import { isEmpty, isNil } from 'lodash'
import { LongDays, ShortDays } from '../components/Exchange/utils'

export const formatHours = (location: Participant) => {
  let hours = ''
  let formattedHours = ''

  if (isNil(location)) return ''

  if (location.businessHours && !isEmpty(location.businessHours.businessHoursOrdered)) {
    hours = location.businessHours.businessHoursOrdered
  } else if (location.businessHours && !isEmpty(location.businessHours.towHoursOrdered)) {
    hours = location.businessHours.towHoursOrdered
  }

  if (!isEmpty(hours) && typeof hours === 'object') {
    for (const [key, value] of Object.entries(hours)) {
      if (!Object.keys(LongDays).includes(key) && !Object.keys(ShortDays).includes(key)) continue
      formattedHours += `${key}: ${value} `
    }
  }
  return formattedHours
}
